/**
 * Check if the user has the given perm for the given group.
 *
 * @param groupId
 *            the group id as string
 * @param perm
 *            the perm as a string
 * @return a promise containing the value true if the user has the perm, false else
 */
define('utils/perm-checker',['jquery'], function($) {
    return function(groupId, perm) {
        return $.get('/group/' + groupId + '/perm/' + perm + '/check').then(function(data) {
            return data.hasPerm;
        });
    };
});

